/** Tiago AI — client config (mirror functions/tiagoPlans.js) */
export const TIAGO_FREE_LIMIT = 3;

export const PLANS = [
  {
    id: 'fan',
    name: 'Fan',
    price: '€3.99',
    period: 'mo',
    messages: 50,
    label: '50 messages/month',
    color: '#6c757d',
    highlight: false,
    priceId: import.meta.env.VITE_TIAGO_STRIPE_PRICE_FAN || '',
    features: ['Women\'s football chat', 'Tactics & formations', 'Conversation history'],
  },
  {
    id: 'starter',
    name: 'Starter',
    price: '€6.99',
    period: 'mo',
    messages: 200,
    label: '200 messages/month',
    color: '#4285f4',
    highlight: false,
    priceId: import.meta.env.VITE_TIAGO_STRIPE_PRICE_STARTER || '',
    features: ['Everything in Fan', 'Player & team stats', 'League analysis'],
  },
  {
    id: 'plus',
    name: 'Plus',
    price: '€12.99',
    period: 'mo',
    messages: 600,
    label: '600 messages/month',
    color: '#e91e8c',
    highlight: true,
    priceId: import.meta.env.VITE_TIAGO_STRIPE_PRICE_PLUS || '',
    features: ['Everything in Starter', 'Coaching deep-dives', 'Priority responses'],
  },
  {
    id: 'pro',
    name: 'Pro',
    price: '€15.99',
    period: 'mo',
    messages: -1,
    label: 'Unlimited messages',
    color: '#1a1a2e',
    highlight: false,
    priceId: import.meta.env.VITE_TIAGO_STRIPE_PRICE_PRO || '',
    features: ['Everything in Plus', 'Unlimited messages', 'Early access to new features'],
  },
];

export const PLAN_LIMITS = { fan: 50, starter: 200, plus: 600, pro: -1 };

export const LEAGUE_OPTIONS = [
  { id: '', label: 'All women\'s football' },
  { id: 'WSL', label: 'Barclays WSL' },
  { id: 'NWSL', label: 'NWSL' },
  { id: 'UWCL', label: 'UWCL' },
  { id: 'WSL2', label: 'WSL 2' },
  { id: 'Liga F', label: 'Liga F' },
  { id: 'Frauen-Bundesliga', label: 'Frauen-Bundesliga' },
  { id: 'A-League Women', label: 'A-League Women' },
];

export const MODE_OPTIONS = [
  { id: 'fan', label: 'Fan mode' },
  { id: 'coach', label: 'Coach mode' },
];

export function getQuotaState(userData) {
  const plan = userData?.plan && PLAN_LIMITS[userData.plan] !== undefined ? userData.plan : null;
  if (!plan) {
    const used = userData?.tiagoFreeUsed ?? userData?.messageCount ?? 0;
    return {
      plan: null,
      planMeta: null,
      used,
      limit: TIAGO_FREE_LIMIT,
      isFree: true,
      label: `${used}/${TIAGO_FREE_LIMIT} free questions`,
      pct: Math.min((used / TIAGO_FREE_LIMIT) * 100, 100),
      exhausted: used >= TIAGO_FREE_LIMIT,
    };
  }
  const limit = PLAN_LIMITS[plan];
  const used = userData?.messageCount || 0;
  return {
    plan,
    planMeta: PLANS.find((p) => p.id === plan),
    used,
    limit,
    isFree: false,
    label: limit === -1 ? 'Unlimited' : `${used}/${limit} messages`,
    pct: limit === -1 ? 100 : Math.min((used / limit) * 100, 100),
    exhausted: limit !== -1 && used >= limit,
  };
}
